<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="rtRouteMaterials"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="工艺路线">
            <el-input v-model.trim="filter.routingName" placeholder="请输入工艺路线名称" clearable/>
          </el-form-item>
          <el-form-item label="工艺状态">
            <el-select v-model="filter.status" placeholder="请选择工艺状态" clearable>
              <el-option label="待确认" :value="10"/>
              <el-option label="已确认" :value="20"/>
              <el-option label="已作废" :value="90"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <!-- <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.detailAuth" type="primary" @click="$refs.rtRouteMaterialEdit.open(scope.row, 1)">详情</el-button>
      </template> -->
    </viewTable>
    <rt-route-material-edit ref="rtRouteMaterialEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import RtRouteMaterialEdit from "./RtRouteMaterialEdit";

  export default {
    name: "RtRouteMaterialList",
    components: {viewTable, RtRouteMaterialEdit},
    data() {
      return {
        limits: {
          addAuth: this.$auth(220),
          editAuth: this.$auth(221),
          detailAuth: this.$auth(222),
          delAuth: this.$auth(223),
        },
        filter: {
          materialNo: "",
          materialName: "",
          routingName: "",
          status: "",
        },
        columnsProperty: [
          {
            key: "routeMaterialNo",
            width: 140,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.rtRouteMaterialEdit.open(params.row, true);
                    },
                  },
                },
                params.row.routeMaterialNo,
              );
            },
          },
          {
            key: "routingName",
            width: 140,
            tooltip: true,
          },
          {
            key: "materialNo",
            width: 160,
          },
          {
            key: "materialName",
            minWidth: 360,
            tooltip: true,
          },
          {
            key: "versionNo",
            width: 80,
            align: "center",
          },
          {
            key: "statusName",
            width: 80,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      // 新增、编辑
      addEditHandle(row) {
        this.$refs.rtRouteMaterialEdit.open(row);
      },

      // 加载数据
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除
      deleteHandle(row) {
        this.$http.post("basic", `rtRouteMaterials/delete/${row.pkid}`).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>
